import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27 18", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "Flag of The Gambia") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m0,0h27v18H0", fill: "#3A7728" }), /* @__PURE__ */ React.createElement("path", { d: "m0,0h27v11H0", fill: "#0C1C8C" }), /* @__PURE__ */ React.createElement("path", { d: "m0,0h27v6H0", fill: "#CE1126" }), /* @__PURE__ */ React.createElement("path", { d: "m0,6.5h27m0,5H0", stroke: "#FFF" }));
const ForwardRef = forwardRef(SvgGm);
const Memo = memo(ForwardRef);
export default Memo;
